<div class="card">
  <div class="card-content">
    <div class="stats-cards-row">
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ totalRecords }}</span>
          <span class="stats-card-label">Total Records</span>
          <span class="stats-card-sublabel">After filters</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-history"></i></div>
      </div>
      <div class="stats-card stats-card--success">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ createdCount }}</span>
          <span class="stats-card-label">Created</span>
          <span class="stats-card-sublabel">On this page</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-plus-circle"></i></div>
      </div>
      <div class="stats-card stats-card--warning">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ updatedCount }}</span>
          <span class="stats-card-label">Updated</span>
          <span class="stats-card-sublabel">On this page</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-pencil"></i></div>
      </div>
      <div class="stats-card stats-card--danger">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ deletedCount }}</span>
          <span class="stats-card-label">Deleted</span>
          <span class="stats-card-sublabel">On this page</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-trash"></i></div>
      </div>
    </div>

    <div class="filter-bar filter-bar-collapsible mb-4"
         [class.filter-bar-visible]="pageHeaderService.currentFiltersVisible">
      <div class="filter-bar-filters">
        <div class="filter-field">
          <label for="categoryFilter" class="filter-label">Category</label>
          <p-select id="categoryFilter" [(ngModel)]="selectedCategory" (ngModelChange)="onCategoryChange()"
            [options]="categoryOptions" optionLabel="label" optionValue="value" placeholder="All categories"
            [showClear]="true" [filter]="true" filterPlaceholder="Search category..."
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label for="entityFilter" class="filter-label">Entity</label>
          <p-select id="entityFilter" [(ngModel)]="selectedEntity" (ngModelChange)="onFilterChange()"
            [options]="entityOptions" optionLabel="label" optionValue="value" placeholder="All entities"
            [showClear]="true" [filter]="true" filterPlaceholder="Search entity..."
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label for="actionFilter" class="filter-label">Action</label>
          <p-select id="actionFilter" [(ngModel)]="selectedAction" (ngModelChange)="onFilterChange()"
            [options]="actionOptions" optionLabel="label" optionValue="value" placeholder="All actions"
            [showClear]="true" panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label for="sourceFilter" class="filter-label">Source</label>
          <p-select id="sourceFilter" [(ngModel)]="selectedSource" (ngModelChange)="onFilterChange()"
            [options]="sourceOptions" optionLabel="label" optionValue="value" placeholder="All sources"
            [showClear]="true" panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label for="changedByFilter" class="filter-label">Changed By</label>
          <input id="changedByFilter" type="text" pInputText [(ngModel)]="changedByFilter"
            (ngModelChange)="onChangedByInput()" placeholder="User name / email" />
        </div>
        <div class="filter-field">
          <label for="fromDate" class="filter-label">From</label>
          <p-datepicker inputId="fromDate" [(ngModel)]="fromDate" (ngModelChange)="onFilterChange()"
            dateFormat="M d, yy" placeholder="Pick a date" [showIcon]="true" [showClear]="true"
            [showButtonBar]="true" [showOnFocus]="false" [maxDate]="toDate || undefined"
            iconDisplay="input" appendTo="body" styleClass="audit-datepicker" />
        </div>
        <div class="filter-field">
          <label for="toDate" class="filter-label">To</label>
          <p-datepicker inputId="toDate" [(ngModel)]="toDate" (ngModelChange)="onFilterChange()"
            dateFormat="M d, yy" placeholder="Pick a date" [showIcon]="true" [showClear]="true"
            [showButtonBar]="true" [showOnFocus]="false" [minDate]="fromDate || undefined"
            iconDisplay="input" appendTo="body" styleClass="audit-datepicker" />
        </div>
      </div>
      <div class="filter-bar-actions" *ngIf="hasActiveFilters()">
        <button type="button" class="btn-clear-filters" (click)="clearFilters()" title="Clear all filters">
          <i class="pi pi-filter-slash"></i>
        </button>
      </div>
    </div>

    <p-table
      [scrollable]="true"
      scrollHeight="flex"
      [value]="logs"
      [loading]="loading"
      [lazy]="true"
      (onLazyLoad)="onLazyLoad($event)"
      [paginator]="true"
      [alwaysShowPaginator]="false"
      [rows]="rows"
      [totalRecords]="totalRecords"
      [first]="first"
      [rowsPerPageOptions]="rowsPerPageOptions"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} audit records"
      dataKey="id"
      [tableStyle]="{ 'min-width': '100%' }"
      styleClass="p-datatable audit-logs-table no-column-lines">

      <ng-template pTemplate="header">
        <tr>
          <th style="width: 3rem"></th>
          <th pSortableColumn="changedAt" style="width: 11rem">
            When
            <p-sortIcon field="changedAt" />
          </th>
          <th style="width: 20rem">Entity</th>
          <th style="width: 7.5rem">Action</th>
          <th style="width: 14rem">Changed By</th>
          <th>What Changed</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-log let-expanded="expanded">
        <tr>
          <td>
            <span *ngIf="log.changes && log.changes.length"
              [pRowToggler]="log" class="row-expand-toggler"
              [attr.title]="expanded ? 'Hide details' : 'View details'">
              <i [class]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></i>
            </span>
          </td>
          <td class="td-when">
            <span class="when-date">{{ log.changedAt | date: 'MMM d, y' }}</span>
            <span class="when-time">{{ log.changedAt | date: 'HH:mm:ss' }}</span>
          </td>
          <td class="td-entity" [pTooltip]="log.entityDisplay || log.entityName">
            <span class="entity-name">{{ log.entityName }}</span>
            <span class="entity-display" *ngIf="log.entityDisplay">{{ log.entityDisplay }}</span>
          </td>
          <td><p-tag [value]="log.action" [severity]="actionSeverity(log.action)" /></td>
          <td class="td-truncate" [pTooltip]="log.changedBy || 'System'">{{ log.changedBy || 'System' }}</td>
          <td class="td-truncate td-summary" [pTooltip]="changeSummary(log)">
            {{ changeSummary(log) }}
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="expandedrow" let-log>
        <tr class="row-expansion-row">
          <td colspan="6">
            <div class="changes-panel">
              <ng-container *ngIf="log.changes && log.changes.length; else noChanges">

                <!-- Created / Deleted: no meaningful "before", show Field / Value only -->
                <div class="changes-grid two-col" *ngIf="isTwoColumn(log)">
                  <div class="cg-head">Field</div>
                  <div class="cg-head">{{ log.action === 'Deleted' ? 'Value (removed)' : 'Value' }}</div>
                  <ng-container *ngFor="let c of log.changes">
                    <div class="cg-cell cg-field">{{ c.field }}</div>
                    <div class="cg-cell"
                      [class.cg-old]="log.action === 'Deleted'"
                      [class.cg-new]="log.action !== 'Deleted'">{{ singleValue(log, c) }}</div>
                  </ng-container>
                </div>

                <!-- Updated: full Field / Old -> New diff -->
                <div class="changes-grid three-col" *ngIf="!isTwoColumn(log)">
                  <div class="cg-head">Field</div>
                  <div class="cg-head">Old Value</div>
                  <div class="cg-head">New Value</div>
                  <ng-container *ngFor="let c of log.changes">
                    <div class="cg-cell cg-field">{{ c.field }}</div>
                    <div class="cg-cell cg-old">{{ displayValue(c.old) }}</div>
                    <div class="cg-cell cg-new">{{ displayValue(c.new) }}</div>
                  </ng-container>
                </div>

              </ng-container>
              <ng-template #noChanges>
                <span class="no-changes">No field-level details for this entry.</span>
              </ng-template>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr class="table-empty-row">
          <td colspan="6" class="table-empty-cell">
            <div class="empty-state">
              <i class="pi pi-history empty-icon"></i>
              <p class="empty-message">No audit records found.</p>
              <p class="empty-description">Try adjusting the filters or date range.</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
